<template>
    <div>
        <div class="align-self-center flit-cabinet" @keyup.enter="enterClicked()">
            
            <div class="flit-cabinet-email" v-if="step == 1">
                <p class="form-text">Введите электронную почту для доступа к отчету</p>
                <input type="email" v-model="email" @change="checkEmail" v-bind:class="emailInvalid ? 'invalid-input' : ''" class="form-input" id="uemail">
                <p class="form-err-msg" v-if="emailInvalid">
                    Некорректное значение email
                </p>
                <p class="form-err-msg" v-if="unknownEmail">
                    Пользователь с данной электронной почтой не зарегистрирован, проверьте правильность ввода или обратитесь к Вашему персональному менеджеру
                </p>
                <p class="form-err-msg" v-if="serverError">
                    При обработке вашего запроса возникла ошибка на сервере. Повторите попытку входа позже.
                </p>
                <p class="form-err-msg" v-if="smsTimeoutError">
                    Превышен лимит запросов на отправку смс кода. Повторите запрос через 1 минуту.
                </p>
                <button type="button" class="btn" @click="emailAuth">ДАЛЕЕ</button>
            </div>
            <div v-if="step==2">
                <p class="cabinet-header step2-header">Введите код из СМС</p>
                <p class="sms-phone-helper" for="polis">Мы отправили его на номер {{userPhone}}</p>
                <div class="sms-input-field">
                <v-otp-input
                    inputClasses="otp-input"
                    :numInputs="4"
                    separator=""
                    :shouldAutoFocus="true"
                    @on-complete="handleOnComplete"
                    />
                </div>
                <p class="form-err-msg sms-error" v-if="codeInvalid">
                    Введен неправильный код
                </p>
                <p class="form-err-msg sms-error" v-if="serverError">
                    При обработке вашего запроса возникла ошибка на сервере. Повторите попытку входа позже.
                </p>
                <p class="form-err-msg sms-error" v-if="smsTimeoutError">
                    Превышен лимит запросов на отправку смс кода. Повторите запрос через 1 минуту.
                </p>
                <p class="code-resend-msg" v-if="btnTimeInfo">
                    Повторная отправка кода через {{btnTimeoutLeft}} секунд.
                </p>
                <button type="button" class="btn code-resend-btn" @click="sendCodeAgain" v-else>Отправить новый код</button>
            </div>
            <div v-if="step==3">
                <p class="cabinet-header step2-header">Выгрузить страховые события с датой</p>
                <div class="data-filters">
                    <div class="data-col data-col-left">
                        <p class="form-fields-name" for="polis">с</p>
                        <input type="date" v-model="dateStart" @change="checkDate" class="input-text" id="dateStart">
                    </div>
                    <div class="data-col data-col-right">
                        <p class="form-fields-name" for="polis">по</p>
                        <input type="date" v-model="dateEnd" @change="checkDate" class="input-text" id="dateEnd">
                    </div>
                </div>
                <p class="form-err-msg" v-if="datesInvalid">
                    Временной период введен неверно
                </p>
                <p class="form-err-msg" v-if="authCodeError">
                    Ошибка аутентификации. Обновите страницу и выполните вход.
                </p>
                <p class="form-err-msg" v-if="serverError">
                    Ошибка на сервере. Повторите запрос позже.
                </p>
                <button type="button" class="center-btn" @click="downloadEvents">Выгрузить в Excel</button>
            </div>
        </div>
        
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'flit-cabinet',
  props: ["isActive"],
	data() {
		let today  = new Date();
		const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit' })
		const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat.formatToParts(today ) 
		let todayFormatedDate = `${year}-${month}-${day}`
		return {
            step: 1,
			serverError: false,
			authToken: "",
			showCancel: false, //for popup
			authenticated: false,
			showBtns: true,
			email: "",
			emailInvalid: false,
			smsTimeoutError: false,
			unknownEmail: false,
			userPhone: "+7(***)***-**-45",
			smsCode: "",
			codeInvalid: false,
			btnTimeInfo: true,
			btnTimeoutLeft: 0,
			dateStart: "",
			dateEnd: todayFormatedDate,
			datesInvalid: false,
			authCodeError: false,
		}
	},
	watch: {
		isActive: function(){
			this.clean()
        },
        step: function() {
            if (this.step == 2) {
                setTimeout(
				function() {
                    let input = $(".otp-input").first().focus();
				}, 200);
            }
        }
    },
    mounted() {
        let vm = this
        let body = document.getElementById("appbody");
        body.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                vm.enterClicked()
            }
        });
    },
	methods: {
        enterClicked() {
            switch (this.step) {
                case 1:
                    this.emailAuth()
                    break
                case 3:
                    this.downloadEvents()
                    break
            }
        },
		backBtn() {
			if ((this.step == 1) || (this.authToken.length > 0)) {
				this.exitBtn()				
			} else {
				this.step -= 1
			}
		},
		exitBtn() {
			if (this.step < 3) {
				this.$emit('exitpopup', "Отменить вход в личный кабинет?")
			} else {
				this.$emit('exitpopup', "Выйти из личного кабинета?")
			}
			
		},
		checkEmail() {
			if (!this.doLiveCheck) {
				return
			}
			this.unknownEmail = false
			console.log(validateEmail(this.email))
			if (!validateEmail(this.email)) {
				this.emailInvalid = true
			} else {
				this.emailInvalid = false
			}
		},
		emailAuth() {
			if(!validateEmail(this.email)) {
				this.doLiveCheck = true
				this.emailInvalid = true
				return
			}
			this.smsTimeoutError = false
			this.doLiveCheck = false
			//Send email to server and check for existence. Send SMS code
			let vm = this
			axios.post( '/api/cabinet/check_email',
				this.email
			).then(function(data){
				let resp = data.data
				vm.serverError = false
				if (resp.Error == "") {
					vm.step = 2
					vm.userPhone = resp.Data.PhoneNum
					vm.btnTimeInfo = true
					vm.btnTimeoutLeft = 60
					let btnTimeout = setInterval(
						function() {
							if (vm.btnTimeoutLeft == 0) {
								vm.btnTimeInfo = false
								clearInterval(btnTimeout);
							} else {
								vm.btnTimeoutLeft -= 1
							}
							
						}, 1000);
				} else {
					vm.unknownEmail = true
				}
			})
			.catch(function(response){
				console.log(response)
				console.log(response.response)
				if (response.response == undefined) {
					vm.serverError = true
				} else {
					if ((response.response.status == 400) && (response.response.data.Error == "SMS code timeout error")) {
						vm.smsTimeoutError = true
						setTimeout(
							function() {
								vm.smsTimeoutError = false
							}, 60000);
					} else {
						vm.doLiveCheck = true
						vm.serverError = true
					}
				}
				
				
			});
		},
		sendCodeAgain() {
			//Send code, shows after 1 minute
			this.emailAuth()
        },
        

        handleOnComplete(value) {
            this.smsCode = value
            this.checkCode()
        },


		checkCode() {
			if (this.smsCode.length > 4) {
				this.smsCode = this.smsCode.substr(0,4)
			}
			// Send and check code
			let vm = this
			axios.post( '/api/cabinet/check_code',
				{
					"Email": this.email,
					"Code":this.smsCode
				}
			).then(function(data){
				let resp = data.data
				vm.serverError = false
				if (resp.Error == "") {
					vm.authToken = resp.Data.Token
					vm.step += 1
				} else {
					vm.codeInvalid = true
				}
			})
			.catch(function(response){
				vm.doLiveCheck = true
				vm.serverError = true
			});
			
		},
		checkDate() {
			if (!this.doLiveCheck) {
				return
			}
			if ((this.dateStart.length == 0) || (this.dateEnd.length == 0)) {
				this.datesInvalid = true
				return
			}
			let startDate = new Date(this.dateStart)
			let endDate = new Date(this.dateEnd)
			if (startDate > endDate) {
				this.datesInvalid = true
				return
			}
			this.datesInvalid = false
		},
		downloadEvents() {
			// Sending redates to server
			this.doLiveCheck = true
			this.checkDate()
			if (!this.datesInvalid) {
				console.log("From", this.dateStart, "to", this.dateEnd)
				let vm = this
				axios.post( '/api/cabinet/report',
					{
						"Email": this.email,
						"Token":this.authToken,
						"DateStart": this.dateStart,
						"DateEnd":this.dateEnd,
					}
				).then(function(data){
					const type = data.headers['content-type']
					const blob = base64toBlob(data.data, type)
					const link = document.createElement('a')
					link.href = window.URL.createObjectURL(blob)
					link.download = 'report.xlsx'
					link.click()
				})
				.catch(function(response){
					let status = response.response.status
					if ((status > 400) && (status < 500)) {
						vm.authCodeError = true
					} else {
						vm.serverError = true
					}
					vm.doLiveCheck = true
				});
			}
		},
		clean() {
			let today  = new Date();
			const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit' })
			const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat.formatToParts(today ) 
			let todayFormatedDate = `${year}-${month}-${day}`
			if (this.authToken == "") {
				this.step= 1
			}
			if (this.step < 3) {
				this.step= 1
				this.serverError = false
				this.smsTimeoutError = false
				this.showCancel = false
				this.authenticated = false
				this.showBtns = true
				this.email = ""
				this.userPhone = ""
				this.smsCode = ""
				this.codeInvalid = false
				this.btnTimeInfo = true
				this.btnTimeoutLeft = 0
				this.dateStart =  ""
				this.dateEnd = todayFormatedDate
				this.datesInvalid = false
				this.authCodeError = false
			}
		}
	}
}
function validateEmail(email) {
	if (!email) {
		return false
	}
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function base64toBlob(base64Data, contentType) {
    let cType = contentType || '';
    let sliceSize = 1024;
    let byteCharacters = atob(base64Data);
    let bytesLength = byteCharacters.length;
    let slicesCount = Math.ceil(bytesLength / sliceSize);
    let byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        let begin = sliceIndex * sliceSize;
        let end = Math.min(begin + sliceSize, bytesLength);

        let bytes = new Array(end - begin);
        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: cType });
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/Cabinet.vue